module.exports = __webpack_public_path__ + "img/risks-sleeping-problems.b3bd3cda.svg";